import React, { useState, useEffect } from "react"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Button } from "@/components/ui/button"
import { Link, useNavigate } from "react-router-dom"
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert"

export default function ResetPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();


  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    if (token) {
      navigate("/");
    }
  }, [navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    

    if (email) {
      setSubmitted(true);     
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="max-w-md w-full p-8 bg-white shadow-lg rounded-lg">
        <div className="flex flex-col items-center gap-4 text-center mb-6">
          <h1 className="text-2xl font-bold">Parola Sıfırlama</h1>
          <p className="text-sm text-gray-500">Lütfen e-posta adresinizi girin, sıfırlama bağlantısı gönderilecektir.</p>
        </div>

        {submitted ? (
          <div className="flex flex-col gap-4">
            <Alert variant="success">
              <AlertTitle>Başarılı</AlertTitle>
              <AlertDescription>
                Parola sıfırlama bağlantısı e-posta adresinize gönderildi. 
                Lütfen e-postanızı kontrol edin.
              </AlertDescription>
            </Alert>
            <div className="text-center text-sm mt-4">
              <p>Giriş sayfasına yönlendiriliyorsunuz...</p>
            </div>
          </div>
        ) : (
          <form className="flex flex-col gap-6" onSubmit={handleSubmit}>
            <div className="grid gap-3">
              <Label htmlFor="email">Email</Label>
              <Input 
                id="email" 
                type="email" 
                placeholder="m@example.com" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required 
              />
            </div>

            <Button type="submit" variant="default" className="w-full">
              Parolayı Sıfırla
            </Button>

            <Link to="/login" className="w-full">
              <Button type="button" variant="outline" className="w-full mt-2">
                Geri Dön
              </Button>
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}